import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AutoLogoutService } from './services/auto-logout.service';
import { UserAuthService } from './services/user-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'GeekWerksLLC';

  constructor(public UserAuth: UserAuthService, private router: Router) {}

  logout() {
    this.UserAuth.user_Logout();
  }
}
